import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withKeys as _withKeys, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "dropdown" }
const _hoisted_2 = ["disabled"]
const _hoisted_3 = { class: "visually-hidden" }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { key: 1 }
const _hoisted_6 = { key: 2 }

import { ref, onMounted, nextTick, computed } from "vue";
import { Dropdown } from "bootstrap";
import PermissionSet from "@/guiide/ts/permissionSet";


export default /*@__PURE__*/_defineComponent({
  __name: 'ThreeDotMenu',
  props: {
  id: { type: Number, required: true },
  permissions: { type: Object as () => PermissionSet, required: true },
  ariaPurpose: { type: String, default: "" }
},
  emits: ["viewClicked", "editClicked", "deleteClicked"],
  setup(__props) {

const props = __props;



const commandList = ref<HTMLElement|null>(null);
const commands = ref<HTMLElement[]>([]);

onMounted(() => {
  const dropdownElement = document.getElementById("dropdownMenu2");
  if (dropdownElement) {
    new Dropdown(dropdownElement);
  }
});

const isDisabled = computed<boolean>(() => !props.permissions.hasAny());

function getAriaPurpose(): string {
  return props.ariaPurpose
    ? `Options for ${props.ariaPurpose}`
    : "Options";
}

const focusFirstItem = async () => {
  await nextTick();
  const items = commandList.value?.querySelectorAll('button.dropdown-item');
  if (items?.length) {
    (items[0] as HTMLElement).focus();
    commands.value = Array.from(items) as HTMLElement[];
  }
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("button", {
      class: "btn btn-light float-end",
      type: "button",
      id: "dropdownMenu2",
      "data-bs-toggle": "dropdown",
      "aria-expanded": "false",
      disabled: isDisabled.value,
      onKeydown: _withKeys(focusFirstItem, ["enter"])
    }, [
      _createElementVNode("span", _hoisted_3, _toDisplayString(getAriaPurpose()), 1),
      _cache[3] || (_cache[3] = _createElementVNode("i", { class: "bi bi-three-dots-vertical" }, null, -1))
    ], 40, _hoisted_2),
    _createElementVNode("ul", {
      ref_key: "commandList",
      ref: commandList,
      class: "dropdown-menu",
      "aria-labelledby": "dropdownMenu2"
    }, [
      (__props.permissions?.canView)
        ? (_openBlock(), _createElementBlock("li", _hoisted_4, [
            _createElementVNode("button", {
              ref_key: "commands",
              ref: commands,
              class: "dropdown-item",
              type: "button",
              tabindex: "0",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('viewClicked', __props.id)))
            }, " View ", 512)
          ]))
        : _createCommentVNode("", true),
      (__props.permissions?.canEdit)
        ? (_openBlock(), _createElementBlock("li", _hoisted_5, [
            _createElementVNode("button", {
              ref_key: "commands",
              ref: commands,
              class: "dropdown-item",
              type: "button",
              tabindex: "0",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('editClicked', __props.id)))
            }, " Edit ", 512)
          ]))
        : _createCommentVNode("", true),
      (__props.permissions?.canDelete)
        ? (_openBlock(), _createElementBlock("li", _hoisted_6, [
            _createElementVNode("button", {
              ref_key: "commands",
              ref: commands,
              class: "dropdown-item",
              type: "button",
              tabindex: "0",
              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('deleteClicked', __props.id)))
            }, " Delete ", 512)
          ]))
        : _createCommentVNode("", true)
    ], 512)
  ]))
}
}

})